<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<ng-container *ngIf="value != null">
	<span>{{ value | number: digitsInfo }}</span>
	<span *ngIf="postfix" class="postfix">{{ postfix }}</span>
</ng-container>
<span *ngIf="value == null">{{ "STATISTICS_PAGE__NA" | transloco }}</span>
